export default __webpack_public_path__ + "static/media/timeshare_light.59fca27b.png";